import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {Link, useHistory} from 'react-router-dom'

import './navbar.css'
import Logo from './../../img/logo.svg'
import MenuOptionHorizontal from './menuOptionHorizotal';
import SigninForm from '../login/signin/signin';
import SignUpForm from '../login/signup/signUp';
import ShopingCard from '../shopingCard/shopingCard';
import HelpMessage from '../utils/helpMessages/helpMessages';




const Navbar = (props) => {

    const history = useHistory();

    const [stateUser, setStateUser] = useState({
        _id:'',
        name:'',
        lastName: '',
        email: '',
        phoneNumber:0,
        password:'',
        fotoAvatar:''
    });

    const userData =({newUser})=>{
        // console.log(newUser) 
        setStateUser(newUser)
        props.updateDataUser(newUser);
        history.push('/');
    }

    const ref = React.createRef();
    const shanwichButtonOpne = React.createRef();
    const shanwichButtonClose = React.createRef();
    // const btnAcceder =React.createRef();

    const [menurotation, setMenurotation] = useState(false);

    const [tipeaAcces, setTipeAcces] = useState(true);


    const showMenu = () => {
        console.log(
            ref.current.classList.toggle("hidden")
        );
        shanwichButtonOpne.current.classList.toggle("hidden");
        shanwichButtonClose.current.classList.toggle("hidden")


        setMenurotation(!menurotation)
    }


    const switchAcces =(boolean)=>{
        setTipeAcces(boolean);
    }

        

    return (
        <div>
            {/* This example requires Tailwind CSS v2.0+ */}
            
            
            <motion.div
                initial="hidden"
                animate="visible"
                transition={{ duration: 0.5 }}
                variants={{
                    visible: { opacity: 1 },
                    hidden: { opacity: 0 }
                }}
            >


                <nav className="navbar-app shadow-sm fixed w-screen z-30 top-0">
                    <div className="max-w-7xl  mx-auto px-2 sm:px-6 md:px-10 lg:px-20">
                        <div className="relative flex items-center justify-between  h-12 sm:h-14">
                            {/*  */}
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                {/* Mobile menu button*/}
                                <div onClick={() => showMenu()} className="inline-flex items-center justify-center p-2 rounded-md text-gray-900 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-expanded="false">

                                    <span className="sr-only">Open main menu</span>
                                    {/* Icon when menu is closed. */}
                                    {/*
                                    Heroicon name: menu

                                    Menu open: "hidden", Menu closed: "block"
                                */}
                                    <svg ref={shanwichButtonOpne} className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                    </svg>

                                    {/* Icon when menu is open. */}
                                    {/*
                                    Heroicon name: x

                                    Menu open: "block", Menu closed: "hidden"
                                */}
                                    <svg ref={shanwichButtonClose} className="hidden block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </div>
                            </div>
                            <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                                <div id="logo-navbar" className="flex-shrink-0 flex items-center">
                                    <motion.div
                                        animate={{
                                            scale: [1, 2, 2, 1, 1],
                                            rotate: [0, 0, 270, 270, 0],
                                            borderRadius: ["20%", "20%", "50%", "50%", "20%"],
                                        }}
                                    >
                                        {/* <img id="logo-navbar" src={Logo} alt="Workflow" className="hidden lg:block h-10 w-auto" />
                                        <img id="logo-navbar" src={Logo} alt="Workflow" className="block lg:hidden h-8 w-auto" /> */}
                                        {/* <img className="block lg:hidden h-8 w-auto" src="https://tailwindui.com/img/logos/workflow-mark-indigo-500.svg" alt="Workflow" /> */}
                                        {/* <img className="hidden lg:block h-8 w-auto" src="https://tailwindui.com/img/logos/workflow-logo-indigo-500-mark-white-text.svg" alt="Workflow" /> */}
                                    </motion.div>
                                    <Link to="/">
                                    <h1 id="logo-title1" className=" block sm:hidden text-green-500 pl-0 pr-3 py-2 rounded-md text-lg capitalize font-extrabold">
                                            {
                                                props?.dataTIENDA?.nameNegocio?
                                                props.dataTIENDA.nameNegocio.substr(0,12)
                                                :
                                                'Mi tienda'
                                            }
                                        </h1>
                                    </Link>
                                </div>
                                <div className="hidden sm:block sm:ml-6">
                                    <div className="flex ">
                                        {/* Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" */}

                                        <Link to="/">
                                        <h1 id="logo-title1" className=" text-green-500 pl-0 pr-3 py-2 rounded-md text-sm capitalize font-medium">
                                            {
                                                props?.dataTIENDA?.nameNegocio?
                                                props.dataTIENDA.nameNegocio.substr(0,25)
                                                :
                                                'Mi tienda online'
                                            }
                                        </h1>
                                        </Link>

                                        {/* <a href="#" className="text-gray-900 hover:text-purple-500 hover:text-white px-3 py-2 rounded-md text-sm font-medium">Mi tienda</a>
                                        <a href="#" className="text-gray-900 hover:text-purple-500 hover:text-white px-3 py-2 rounded-md text-sm font-medium">Productos</a>
                                        <a href="#" className="text-gray-900 hover:text-purple-500 hover:text-white px-3 py-2 rounded-md text-sm font-medium">Servicios</a> */}
                                    </div>
                                </div>
                            </div>

                            {/* Search input */}
                            {/* <div className="bg-yellow-600 p-1 rounded-full  w-64 focus:outline-none  focus:border-transparent">
                            <input className="w-60 border border-transparent focus:outline-none rounded-full" type="text" name="search" id="" placeholder="Buscar..." />
                        </div> */}

                            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">

                                {/* Profile dropdown */}
                                {
                                    stateUser._id !="" || props.userData?._id!=""?

                                        <div className="ml-3 relative">

                                            <div id="btn-user-opcion" className="pb-1">
                                                {/* <motion.div
                                                animate={{
                                                scale: [1, 2, 2, 1, 1],
                                                rotate: [0, 0, 270, 270, 0],
                                                borderRadius: ["20%", "20%", "50%", "50%", "20%"],
                                                }}
                                            > */}
                                                <motion.div whileTap={{scale:0.9}} whileHover={{scale:0.96}} className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" id="user-menu" aria-haspopup="true">
                                                    <span className="sr-only">Open user menu</span>
                                                    {
                                                        !props?.userData?.fotoAvatar
                                                        ?
                                                            <div className="grid justify-items-stretch h-10 w-10 font-semibold text-white  bg-gray-500 rounded-full text-md">
                                                            <div className="my-auto mx-auto">
                                                            { (stateUser?.name?.substr(0,2))?.toUpperCase() || (props?.userData?.name.substr(0,2))?.toUpperCase()}
                                                            </div>
                                                            </div>
                                                        :
                                                            <img className="h-10 w-10 rounded-full" src={ props?.userData?.fotoAvatar!=''?props?.userData?.fotoAvatar:''} alt="" />
                                                    }
                                                </motion.div>
                                                {/* </motion.div> */}

                                                <div id="menu-desplegable" className="hidden">
                                                    <div className="text-white bg-gray-800 pt-6 sm:pt-4 pb-6 sm:pb-2 origin-top-right absolute right-0 mt-1 w-64 sm:w-54 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">
                                                        <div className="pl-4 pb-3 ">
                                                            <div className="font-bold">{stateUser?.name || props?.userData?.name}</div>
                                                            <div>{ props?.userData?.email}</div>
                                                        </div>
                                                        <hr/>
                                                        <Link to="/mitienda"> <a href="#" className="block px-4 py-2 text-sm hover:bg-black" role="menuitem">Mi tienda</a></Link> 
                                                        
                                                        <a href="#" className="block px-4 py-2 text-sm text-gray-400 cursor-default " role="menuitem">Configuración de cuenta</a>
                                                        <a href="#" className="block px-4 py-2 text-sm  text-gray-400 cursor-default" role="menuitem">Configuracion del mapa</a>
                                                        <hr/>
                                                        <a href="#" className="block px-4 py-2 text-sm text-gray-400 cursor-default" role="menuitem">Mensajes</a>
                                                        <a href="#" className="block px-4 py-2 text-sm text-gray-400 cursor-default" role="menuitem">Notificaciones</a>
                                                        <a href="#" 
                                                        onClick={()=>userData({newUser:{_id:'',
                                                                                        name:'',
                                                                                        lastName: '',
                                                                                        email: '',
                                                                                        phoneNumber:0,
                                                                                        password:'',
                                                                                        fotoAvatar:''}})}
                                                        className="block px-4 py-2 text-sm hover:bg-black" role="menuitem">Cerrar sesión</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="">
                                            <motion.div
                                                whileTap={{scale:0.9}}
                                            >

                                                <a 
                                                    href="#modalacceder"
                                                    id="sigin-user"
                                                    className="border border-transparent focus:outline-none focus:ring-0 focus:nono bg-purple-500 focus:border-transparent rounded-2xl text-sm mx-0 px-3 sm:px-5 py-1  font-bold text-color-app "
                                                    style={{paddingBottom:'5px'}}
                                                >
                                                
                                                 {stateUser.name}   ACCEDER
                                                </a>

                                            </motion.div>

                                           
                                            <div id="modalacceder" class="modal-contorl-acces">
                                               
                                               {
                                                   tipeaAcces?
                                                    <SigninForm userData={userData} switchAcces={switchAcces}></SigninForm>
                                                   :
                                                    <SignUpForm userData={userData} switchAcces={switchAcces} ></SignUpForm>
                                               }
                                                
                                            </div>


                                            {/* <motion.button
                                                whileTap={{scale:0.9}}
                                            >
                                                <button className=" text-color-app focus:outline-none focus:ring-0">
                                                    REGISTRARSE
                                                </button>
                                            </motion.button> */}
                                            
                                           
                                        </div>


                                }

                                {/* Shoping card */}



                            </div>
                        </div>
                    </div>
                    {/*
                    Mobile menu, toggle classes based on menu state.

                    Menu open: "block", Menu closed: "hidden"
                */}

                    <motion.div
                        initial={{ opacity: 0, x: -10 }}
                        animate={{opacity:1, x: menurotation ? -3 : 400 }}
                        transition={{ duration: 0.2 }}
                        // exit={{ x: menurotation ? -12 : 0 }}
                        className="bg-white"
                    >
                        <div className="hidden sm:hidden h-screen" ref={ref}>
                            <div className="menu-page px-2 pt-2 pb-3 space-y-1">
                                {/* Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" */}
                                <a href="/" className="text-gray-900 font-bold text-white block px-3 py-2 rounded-md  font-medium">Inicio</a>
                                <a href="https://www.nuxtbo.digital/" className="text-gray-900 font-bold text-white block px-3 py-2 rounded-md  font-medium">Ir a Nuxtbo</a>
                                <a href="#" className="text-gray-400 font-bold block px-3 py-2 rounded-md text-base ">Mas tiendas</a>
                                <a href="#" className="text-gray-400 font-bold block px-3 py-2 rounded-md text-base ">Productos en oferta</a>
                                <a href="#" className="text-gray-400 font-bold block px-3 py-2 rounded-md text-base ">Eventos especiales</a>

                            </div>

                        </div>
                    </motion.div>

                    {/* <MenuOptionHorizontal>

                    </MenuOptionHorizontal> */}
                </nav>

              
            </motion.div>

            {/* <div className="container">

            {JSON.stringify(stateUser)}
            </div> */}

            {/* <ShopingCard></ShopingCard> */}

        </div>
    );
}


export default Navbar;